module.exports = __webpack_public_path__ + "static/media/pin_vetrocar_highlighted.434c97fe.png";